import { endpoint } from '../helpers/Endpoints';
import * as FetchAction from './FetchActionGeneric';

export const LOADING_META_PRODUCT_HEADER_PRICES =
	'@mpwa/LOADING_META_PRODUCT_HEADER_PRICES';
export const LOADING_META_PRODUCT_HEADER_PRICES_SUCCESS =
	'@mpwa/LOADING_META_PRODUCT_HEADER_PRICES_SUCCESS';
export const LOADING_META_PRODUCT_HEADER_PRICES_ERROR =
	'@mpwa/LOADING_META_PRODUCT_HEADER_PRICES_ERROR';

export const LOADING_RECOMMENDATIONS_HEADER_PRICES =
	'@mpwa/LOADING_RECOMMENDATIONS_HEADER_PRICES';
export const LOADING_RECOMMENDATIONS_HEADER_PRICES_SUCCESS =
	'@mpwa/LOADING_RECOMMENDATIONS_HEADER_PRICES_SUCCESS';
export const LOADING_RECOMMENDATIONS_HEADER_PRICES_ERROR =
	'@mpwa/LOADING_RECOMMENDATIONS_HEADER_PRICES_ERROR';

export const LOADING_SEARCH_RESULTS_HEADER_PRICES =
	'@mpwa/LOADING_SEARCH_RESULTS_HEADER_PRICES';
export const LOADING_SEARCH_RESULTS_HEADER_PRICES_SUCCESS =
	'@mpwa/LOADING_SEARCH_RESULTS_HEADER_PRICES_SUCCESS';
export const LOADING_SEARCH_RESULTS_HEADER_PRICES_ERROR =
	'@mpwa/LOADING_SEARCH_RESULTS_HEADER_PRICES_ERROR';

export function loadMetaProductHeaderPrices(
	blueprintId: number,
	productNumbers: string[]
) {
	return loadProductHeaderPrices(
		LOADING_META_PRODUCT_HEADER_PRICES,
		blueprintId,
		productNumbers
	);
}

export function loadProductHeaderPrices(
	startAction: string,
	blueprintId: number,
	productNumbers: string[]
) {
	return FetchAction.CreateFetchAction({
		url: endpoint.productHeaderPrices(blueprintId),
		method: 'POST',
		body: JSON.stringify(productNumbers),
		startAction,
	});
}
